<template>
  <a class="latest-news-item-outer"
      :href="href"
  >
    <div class="latest-news-item">
      <img :src="item.imageUrls">
      <div>
        <div class="item-title">{{item.actionTitle}}</div>
        <div class="item-desc">
<!--          <div>{{item.address + '|' + '赛事'}}</div>-->
          <div>{{itemDate(item)}}</div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "LatestNewsItemCard",
  props: [
    'item',
    'href'
  ],
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {
  },
  methods: {
    itemDate(item) {
      return this.$moment(item.createTime).format('yyyy.MM.DD');
    }
  }
}
</script>

<style scoped>

  .latest-news-item-outer {
    text-decoration: none;
    margin-top: 30px;
    display: inline-block;
    width: 100%;
  }

  .latest-news-item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    /*width: 100%;*/
    /*background-color: yellow;*/
  }

  .latest-news-item > img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }

  .latest-news-item > div {
    width: 100%;
    margin-left: 5%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-top: 10px;
  }

  .latest-news-item .item-title {
    font-size: 1.5rem;
    color: #333;
    text-align: left;
  }

  .latest-news-item .item-desc {
    font-size: 1rem;
    color: #666;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    flex-wrap: nowrap;
    margin-top: 10px;
  }

  @media screen and (min-width: 768px) {

    .latest-news-item {
      justify-content: flex-start;
    }
    .latest-news-item > img {
      width: 20%;
      height: auto;
      border-radius: 8px;
    }

    .latest-news-item > div {
      width: 75%;
      margin-left: 5%;
      margin-top: 0;
      min-height: 70px;
    }

    .latest-news-item .item-desc {
      margin-top: 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/news/LatestNewsItemCard.vue